import { ReactComponent as CloseIcon } from "assets/images/iconsV2/x-close.svg";

const ModalHeader = function (props: any) {
  const { onHide, children, closeButtonTestId } = props;

  return (
    <div className="cb-modal__header">
      <div>{children}</div>
      <div className="cursor-pointer">
        <CloseIcon onClick={onHide} data-testid={closeButtonTestId} />
      </div>
    </div>
  );
};

export default ModalHeader;
